export const environment = {
  production: false,
  name: 'Development',
  CRD_API: 'https://api-traceability-crd-development.agridence.com/api/'
};
